import { ThemeProvider } from 'styled-components';
import { createBrowserHistory, History } from 'history';
import { BrowserRouter } from 'react-router-dom';
import { FloraProvider } from '@grupoboticario/flora-react';
import { gbInstitucionalTheme } from '@grupoboticario/flora';
import { useGlobalContext } from 'context/useGlobalContext';
import StoreListProvider from 'context/StoreListContext';
import { Provider } from 'react-redux';
import environment from 'environments/environment';
import GlobalStyle from 'styles/global';
import { defaultTheme } from 'styles/themes';
import { store } from './store';
import { RoutesComponent } from './routes';
import { globalContext, GlobalContext } from './context/global';
import 'config/yupLocale';

export const defaultHistory = createBrowserHistory();
interface AppProps {
  history?: History;
  path?: string;
  host?: string;
  containerContext?: any;
}

const App = (props: AppProps): JSX.Element => {
  const { history, path, host, containerContext } = props;
  const globalContextValues: GlobalContext = useGlobalContext(
    path,
    host,
    containerContext,
  );

  if (!path) {
    window.location.assign(environment.urlExtranet);
    return <></>;
  }
  return (
    <ThemeProvider theme={defaultTheme}>
      <Provider store={store}>
        <GlobalStyle host={host} />

        <globalContext.Provider value={globalContextValues}>
          <StoreListProvider>
            <FloraProvider theme={gbInstitucionalTheme}>
              <BrowserRouter>
                <RoutesComponent path={path} />
              </BrowserRouter>
            </FloraProvider>
          </StoreListProvider>
        </globalContext.Provider>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
